"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsx_runtime_1 = require("react/jsx-runtime");
var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));
var component_wbr_string_1 = __importDefault(require("@rotaryintl/component-wbr-string"));
var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));
require("./styles.css");
var ThreeColumnImageCallout = function (props) {
  if (!props.imageCallouts || props.imageCallouts.length <= 0) {
    return null;
  }
  var bem = (0, hook_use_bem_classes_1.default)('rwc-three-column-image-callout');
  return (0, jsx_runtime_1.jsx)("section", __assign({
    className: bem(),
    id: props.id
  }, {
    children: props.imageCallouts.map(function (callout) {
      return (0, jsx_runtime_1.jsxs)("div", __assign({
        className: bem('callout')
      }, {
        children: [callout.image && callout.image, (0, jsx_runtime_1.jsxs)("div", __assign({
          className: bem('card')
        }, {
          children: [callout.title && (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
            tag: "h5",
            className: bem('card-title')
          }, {
            children: callout.title
          })), callout.description && (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
            tag: "div",
            className: bem('card-description')
          }, {
            children: callout.description
          })), callout.link && (0, jsx_runtime_1.jsxs)("a", __assign({
            className: bem('card-link'),
            href: callout.link.linkUrl,
            target: callout.link.linkTarget
          }, {
            children: [(0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
              tag: "span"
            }, {
              children: callout.link.linkText
            })), callout.link.external && (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
              type: "fas-external-link",
              style: {
                height: 14,
                width: 14
              }
            })]
          }))]
        }))]
      }), "callout-".concat(callout.title));
    })
  }));
};
exports.default = ThreeColumnImageCallout;